import { zipKeyValue } from "@ixfx/core/maps";
import { syncToArray } from "./sync-to-array.js";
import { transform } from "./transform.js";
export function syncToObject(reactiveSources, options = {}) {
    const keys = Object.keys(reactiveSources);
    const values = Object.values(reactiveSources);
    const s = syncToArray(values, options);
    const st = transform(s, (streamValues) => {
        return zipKeyValue(keys, streamValues);
    });
    return st;
}
